import React from 'react';
import ArrowIcon from '../Assests/Wellness/arrow.png'
import img1 from '../Assests/Diabetes/Diabetes/hero_img.png';


const page1 = () => {
    return (
        <div className='page1-container-new '>
           <div className='page1-left'>
                <p>Diabetes / Pre-diabetes CLINICAL Study </p>
                <p>Are you <span style={{ color: "#DA6E0B" }}>Diabetic or Pre-Diabetic ?</span></p>
                <p>Did You Know ? Not all Diabetes are the same</p>
                <p>Join AyurAI’s clinical study to uncover and treat the root causes of your diabetes insulin resistance, inflammation, gut imbalance, and stress-with personalized, evidence-based care</p>
                {/* <p>This groundbreaking study enables us to identify what's causing diabetes in you and address that specific root issue with personalized, evidence-based approach. </p> */}
                <a 
                    href="https://docs.google.com/forms/d/e/1FAIpQLSfy2A9Hee2WLcX7L8Ek1Q_UwbVc8whejMek-wJKfGUOfHwX6A/viewform?usp=header" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    >
                    
                    <button className="button-wellness">
                        <img src={ArrowIcon} className="w-10 h-10" />
                        Express Interest
                    </button>
                </a>
         
           </div>
           <div className='page1-right '>
                <img src={img1} className='page1-img2'></img>
           </div>
        </div>
    )
} 
export default page1;